<template>
  <v-container fluid>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.CREATE') }} {{ $t('EMPLOYEES.ITEM') }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="error" dark v-bind="attrs" v-on="on">
                  mdi-information-variant-circle-outline
                </v-icon>
              </template>
              <span>{{ $t('EMPLOYEES.M_TYPE_MESSAGE') }}</span>
            </v-tooltip>
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>

    <v-row class="mt-3">
      <v-col cols="12">
        <v-card :loading="loading">
          <v-card-title class="font-weight-regular">
            {{ $t('EMPLOYEES.MAIN_INFORMATION') }}
            <v-spacer />
            <div>
              <v-chip-group readonly>
                <v-chip class="mr-4" color="primary" small>
                  {{ $t('STATUS.ACTIVE') }}
                </v-chip>
              </v-chip-group>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <employee-main-info-form
              v-model="form.main_information"
              :errors="errors.get('main_information')"
              @update-prop="clearErrorByName($event, 'main_information')"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card :loading="loading">
          <v-card-title class="font-weight-regular">
            {{ $t('EMPLOYEES.ACCESS_TO_THE_MYE_REPORTER') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-form ref="form" v-model="valid" @input="$emit('valid', $event)">
              <employee-access-mye-reporter-form
                v-model="form.user"
                :errors="errors.get('user')"
                @update-prop="clearErrorByName($event, 'user')"
              />
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card :loading="loading">
          <v-card-title class="font-weight-regular">
            {{ $t('EMPLOYEES.CONTACT_INFORMATION') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <employee-contact-information-form
              v-model="form.contacts"
              :errors="errors.get('contacts')"
              @update-prop="clearErrorByName($event, 'contacts')"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card :loading="loading">
          <v-card-title class="font-weight-regular">
            {{ $t('EMPLOYEES.ADDITIONAL_INFORMATION') }}
            <v-spacer></v-spacer>
            <v-checkbox
              v-model="form.additional_information.is_service_employee"
              name="is_service_employee"
              class="pr-4"
              :label="$t('EMPLOYEES.SERVICE_EMPLOYEE')"
              :error="errors.is_service_employee"
            ></v-checkbox>
            <v-checkbox
              v-model="form.additional_information.is_concierge"
              name="is_concierge"
              :label="$t('BUILDING_COMPLEXES.CONCIERGE')"
              :error="errors.is_concierge"
            ></v-checkbox>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <employee-additional-information-form
              v-model="form.additional_information"
              :errors="errors.get('additional_information')"
              @update-prop="clearErrorByName($event, 'additional_information')"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-spacer />
        <v-btn elevation="24" large color="primary" @click="create">
          {{ $t('BUTTON.CREATE') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import EmployeeMainInfoForm from '@/modules/employees/components/forms/EmployeeMainInfoForm';
import EmployeeAccessMyeReporterForm from '@/modules/employees/components/forms/EmployeeAccessMyeReporterForm';
import EmployeeContactInformationForm from '@/modules/employees/components/forms/EmployeeContactInformationForm';
import EmployeeAdditionalInformationForm from '@/modules/employees/components/forms/EmployeeAdditionalInformationForm';
import { EmployeesService } from '@/services/employees.service';
import getAdditionalInfo from '@/modules/employees/components/mixins/get-additional-info';
import { mapCacheActions } from 'vuex-cache';
import { EMPLOYEE } from '@/modules/persons/common/roles';

export default {
  name: 'EmployeesCreatePage',

  components: {
    EmployeeAdditionalInformationForm,
    EmployeeContactInformationForm,
    EmployeeAccessMyeReporterForm,
    EmployeeMainInfoForm
  },

  mixins: [errors, getAdditionalInfo],

  data: () => ({
    valid: true,
    form: {
      type: 'manually',
      main_information: { is_active: true },
      contacts: {},
      user: {
        roles: []
      },
      additional_information: {
        is_concierge: false,
        is_service_employee: false
      }
    }
  }),

  computed: {
    ...mapGetters(['loading'])
  },

  created() {
    this.retrieveRoles().then(({ data }) => {
      this.form.user.roles = data.filter(v => v.id === EMPLOYEE);
    });
  },

  methods: {
    ...mapCacheActions('role', ['retrieveRoles']),
    create() {
      EmployeesService.create({
        ...this.form,
        additional_information: this.getAdditionalInformation
      })
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$router.push({ name: 'employees' });
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
